/**
 * Modern Card Component
 * Reusable card component with modern design
 */

import React from 'react';
import './ModernCard.css';

const ModernCard = ({ 
  children, 
  className = '', 
  variant = 'default',
  padding = 'lg',
  shadow = 'md',
  hover = false,
  onClick,
  ...props 
}) => {
  const baseClasses = 'modern-card';
  const variantClasses = `modern-card--${variant}`;
  const paddingClasses = `modern-card--padding-${padding}`;
  const shadowClasses = `modern-card--shadow-${shadow}`;
  const hoverClasses = hover ? 'modern-card--hover' : '';
  const clickableClasses = onClick ? 'modern-card--clickable' : '';

  const cardClasses = [
    baseClasses,
    variantClasses,
    paddingClasses,
    shadowClasses,
    hoverClasses,
    clickableClasses,
    className
  ].filter(Boolean).join(' ');

  return (
    <div 
      className={cardClasses}
      onClick={onClick}
      {...props}
    >
      {children}
    </div>
  );
};

export default ModernCard;
